import { render, staticRenderFns } from "./ZimiCaseStudy.vue?vue&type=template&id=28227d82&scoped=true"
import script from "./ZimiCaseStudy.vue?vue&type=script&lang=js"
export * from "./ZimiCaseStudy.vue?vue&type=script&lang=js"
import style0 from "./ZimiCaseStudy.vue?vue&type=style&index=0&id=28227d82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28227d82",
  null
  
)

export default component.exports